// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b8c488a6]:export {\n  primaryColor: #101928;\n  menuText: white;\n  menuActiveText: #1596d2;\n  subMenuActiveText: white;\n  menuBg: #1a2739;\n  menuHover: rgba(73, 85, 105, 0.4);\n  subMenuBg: #001429;\n  subMenuHover: rgba(73, 85, 105, 0.4);\n  sideBarWidth: 240px;\n  linkColor: #037aff;\n}\n", ""]);
// Exports
module.exports = exports;
